const getResourceType = (resource: { type: string }) => {
    switch (resource.type) {
        case 'ticket.issued':
            return 'ticket';
        case 'transaction.recieved':
        case 'transaction.succeeded':
            return 'transaction';
        case 'recurring_plan.created':
            return 'transaction_plan';
        case 'inbound_email':
            // @todo must be updated
            return null;
        case 'email':
            // @todo must be updated  source === system
            return null;
        default:
            return null;
    }
};

const getResourceTypeFriendly = (resource: { type: string }) => {
    if (resource?.type === undefined) {
        return 'activity';
    }
    switch (resource.type) {
        case 'ticket.issued':
            return 'ticket';
        case 'transaction.recieved':
        case 'transaction.succeeded':
            return 'transaction';
        case 'recurring_plan.created':
            return 'recurring donation';
        case 'inbound_email':
        case 'email':
            return 'email';
        case 'note':
            return 'note';
        case 'sms':
            return 'SMS';
        case 'phone_call':
            return 'phone call';
        default:
            return 'activity';
    }
};

export { getResourceType, getResourceTypeFriendly };
